import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Select.scss';

const Select = ({ options, className, ...props }) => {
  return (
    <div className={classNames('form-group form-group-mob', props.containerClassName)}>
      {props.label && (
        <label
          className={classNames('form-control-label', props.labelClassName, {
            'is-invalid': props.valid === false,
            'is-valid': props.valid === true,
          })}
          htmlFor={props.id}
        >
          {props.label}
        </label>
      )}
      <select
        {...props}
        className={classNames(
          'form-control sm-select',
          {
            'is-invalid': props.valid === false,
            'is-valid': props.valid === true,
          },
          className,
        )}
      >
        {(props.placeholder !== undefined || props.nullable) && (
          <option
            value=""
            // disabled={!props.nullable}
            disabled={!props.nullable}
            selected={['', undefined, null].includes(props.value)}
          >
            {props.placeholder || ''}
          </option>
        )}
        {options.map(option => (
          <option
            key={
              option[props.itemValue] === undefined && typeof option !== 'object'
                ? option
                : option[props.itemValue]
            }
            value={
              option[props.itemValue] === undefined && typeof option !== 'object'
                ? option
                : option[props.itemValue]
            }
          >
            {option[props.itemLabel] === undefined && typeof option !== 'object'
              ? option
              : option[props.itemLabel]}
          </option>
        ))}
      </select>
      {props.valid === false && (
        <div className="invalid-feedback text-left">{props.invalidFeedback}</div>
      )}
      {props.valid === true && (
        <div className="valid-feedback text-left">{props.validFeedback}</div>
      )}
      {props.helperText && (
        <small className="form-text text-muted text-left">{props.helperText}</small>
      )}
    </div>
  );
};

Select.propTypes = {
  options: PropTypes.array,
  className: PropTypes.string,
  itemValue: PropTypes.string,
  itemLabel: PropTypes.string,
};

Select.defaultProps = {
  options: [],
  itemValue: 'value',
  itemLabel: 'label',
  nullable: true,
};

export default Select;
